function tfInitHeader() {
  if (window.tfHeaderInitialized) return;
  window.tfHeaderInitialized = true;
  // ── Desktop mega-menu / dropdown ──
  var navItems = document.querySelectorAll('#tf-nav-bar .tf-nav-item[data-menu]');
  var activeItem = null;

  function openMenu(item) {
    if (activeItem && activeItem !== item) closeMenu(activeItem);
    item.classList.add('is-open');
    var header = document.getElementById('tf-header');
    if (header) {
      header.classList.add('tf-desktop-menu-open');
      var headerSection = header.parentElement;
      if (headerSection) headerSection.classList.add('tf-desktop-menu-layer-active');
    }
    var btn = item.querySelector('[data-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    activeItem = item;
  }

  function closeMenu(item) {
    item.classList.remove('is-open');
    var btn = item.querySelector('[data-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (activeItem === item) activeItem = null;
    if (!activeItem) {
      var header = document.getElementById('tf-header');
      if (header) {
        header.classList.remove('tf-desktop-menu-open');
        var headerSection = header.parentElement;
        if (headerSection) headerSection.classList.remove('tf-desktop-menu-layer-active');
      }
    }
  }

  navItems.forEach(function(item) {
    var btn = item.querySelector('[data-toggle]');
    if (!btn) return;

    // Click toggle
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      if (item.classList.contains('is-open')) {
        closeMenu(item);
      } else {
        openMenu(item);
      }
    });

    // Hover open/close with small delay
    var hoverTimer;
    item.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimer);
      openMenu(item);
    });
    item.addEventListener('mouseleave', function() {
      hoverTimer = setTimeout(function() { closeMenu(item); }, 120);
    });
  });

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (activeItem && !activeItem.contains(e.target)) {
      closeMenu(activeItem);
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && activeItem) closeMenu(activeItem);
  });

  // Keep the entire custom-header section above page content while predictive
  // search results are open. This mirrors the established mega-menu safeguard
  // and avoids Safari stacking-context rendering behind the hero or content.
  var predictiveHeader = document.getElementById('tf-header');
  var predictiveSearch = predictiveHeader && predictiveHeader.querySelector('predictive-search');
  function syncPredictiveSearchLayer() {
    if (!predictiveHeader || !predictiveSearch) return;
    var isSearchOpen = predictiveSearch.hasAttribute('open');
    predictiveHeader.classList.toggle('tf-predictive-search-open', isSearchOpen);
    var predictiveSection = predictiveHeader.parentElement;
    if (predictiveSection) predictiveSection.classList.toggle('tf-predictive-search-layer-active', isSearchOpen);
  }
  if (predictiveSearch) {
    new MutationObserver(syncPredictiveSearchLayer).observe(predictiveSearch, { attributes: true, attributeFilter: ['open'] });
    syncPredictiveSearchLayer();
  }

  // ── Mobile drawer ──
  var hamburger = document.getElementById('tf-hamburger-btn');
  var drawer = document.getElementById('tf-drawer');
  var overlay = document.getElementById('tf-drawer-overlay');
  var closeBtn = document.getElementById('tf-drawer-close');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // ── Mobile accordion ──
  var drawerToggles = document.querySelectorAll('#tf-drawer [data-drawer-toggle]');
  drawerToggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var li = btn.closest('[data-drawer-item]');
      if (!li) return;
      var isOpen = li.classList.contains('is-open');
      // Close all others and keep screen-reader state aligned with the visible panel.
      document.querySelectorAll('#tf-drawer [data-drawer-item].is-open').forEach(function(el) {
        el.classList.remove('is-open');
        var openToggle = el.querySelector('[data-drawer-toggle]');
        if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        li.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });
}
// Run after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tfInitHeader);
} else {
  tfInitHeader();
}
